import React from "react";

import { Icon, IconProps } from "../";

export const CreditCardIcon = (props: IconProps) => {
  return (
    <Icon {...props}>
      <path
        fillRule="evenodd"
        d="M110,434 L110,442 C110,443.104569 109.104569,444 108,444 L92,444 C90.8954305,444 90,443.104569 90,442 L90,434 L110,434 Z M106,440 L100,440 L100,442 L106,442 L106,440 Z M96,436 L94,436 C93.4477153,436 93,436.447715 93,437 L93,437 L93,439 C93,439.552285 93.4477153,440 94,440 L94,440 L96,440 C96.5522847,440 97,439.552285 97,439 L97,439 L97,437 C97,436.447715 96.5522847,436 96,436 L96,436 Z M108,436 L100,436 L100,438 L108,438 L108,436 Z M108,428 C109.104569,428 110,428.895431 110,430 L110,432 L90,432 L90,430 C90,428.895431 90.8954305,428 92,428 L108,428 Z"
        transform="translate(-88 -424)"
      />
    </Icon>
  );
};
